const currencySelect = () => {
  const currencySelectors = document.querySelectorAll('.currency-select');
  if (!currencySelectors.length) return;
  currencySelectors.forEach((select) => {
    const thisForm = select.form;
    select.addEventListener('change', () => {
      thisForm.submit();
    });
  });
};

export default currencySelect;
